import React from 'react'
import clsx from 'clsx'
import Skeleton from 'components/shared/Skeleton'
import styles from './styles.module.scss'
import FollowingAsset from './FollowingAsset/FollowingAsset'

type Props = {
  data: any,
  loading?: boolean,
}

export default function AssetsTable({ data, loading }: Props) {
  if (loading && !data?.length) {
    return (
      <div className={styles.assetTable}>
        <div className={styles.assetHeader}>
          <span>Name</span>
          <span>1 Day</span>
          <span>Price</span>
          <span>24h</span>
          <span>Mrkt Cap</span>
        </div>
        {Array.from(Array(12).keys()).map((item: number) => (
          <div className={styles.assetTableItem} key={item}>
            <Skeleton className={styles.assetRow} />
          </div>
        ))}
      </div>
    )
  }

  if (!data?.length) {
    return null
  }
  return (
    <div className={clsx(styles.assetTable, loading ? 'blockLoading' : '')}>
      <div className={styles.assetHeader}>
        <span>Name</span>
        <span>1 Day</span>
        <span>Price</span>
        <span>24h</span>
        <span>Mrkt Cap</span>
      </div>
      {data?.map((asset: any) => (
        <div className={styles.assetTableItem} key={asset?.objectID}>
          <FollowingAsset key={asset?.objectID} asset={asset?.details} />
        </div>
      ))}
    </div>
  )
}
